module.exports = __webpack_public_path__ + "static/simon-fshot-kesto-60c78e28eaaf9907710b5e73226a7a67.jpg";